export function extractPathSegments(pathname: string): string[] {
  const path = pathname.split("?")[0]?.trim() ?? "";
  if (!path || path === "/") return [];
  return path
    .replace(/^\/+|\/+$/g, "")
    .split("/")
    .map((segment) => segment.trim().toLowerCase())
    .filter(Boolean);
}

export function buildFlexibleSlugs(pathname: string): string[] {
  const segments = extractPathSegments(pathname);
  const normalised = segments.length > 0 && segments[0] === "fr" ? segments.slice(1) : segments;
  if (normalised.length === 0) return [];

  const seen = new Set<string>();
  const ordered: string[] = [];

  for (const segment of [...normalised].reverse()) {
    if (!segment || seen.has(segment)) continue;
    seen.add(segment);
    ordered.push(segment);
  }

  return ordered;
}
